// extracted by mini-css-extract-plugin
export default {"CalculatorsContainer":"Calculators_CalculatorsContainer__plm-P"};